import Landing from "./components/Landing";
import Cam from "./components/Cam";
import ActivaSolo from "./components/ActivaSolo";
import SMS from "./components/SMS";
import RecargaTe from "./components/RecargaTe";
import Idea from "./components/Idea";
import AvisoDePrivacidad from "./components/AvisoDePrivacidad";
import AvisoDePrivacidadv2 from "./components/AvisoDePrivacidadv2";


const routes = [
  { path: '/', component: Landing, name: 'Landing' },
  { path: '/CAM', component: Cam, name: 'Cam' },
  { path: '/Activa-Solo', component: ActivaSolo, name: 'ActivaSolo' },
  { path: '/SMS', component: SMS, name: 'SMS' },
  { path: '/Recarga-Te', component: RecargaTe, name: 'RecargaTe' },
  { path: '/Idea', component: Idea, name: 'Idea' },
  { path: '/AvisoDePrivacidad', component: AvisoDePrivacidad, name: 'AvisoDePrivacidad' },
  { path: '/AvisoDePrivacidadv2', component: AvisoDePrivacidadv2, name: 'AvisoDePrivacidadv2' },
]

export default routes


const routesAPi = ['/', '/CAM','/Activa-Solo','/SMS','/Recarga-Te']
